import React, { useState, useEffect } from 'react'
import { motion } from 'framer-motion'
import { ExternalLink } from 'lucide-react'

const Navbar: React.FC = () => {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768)
    }
    
    checkMobile()
    window.addEventListener('resize', checkMobile)

    return () => {
      window.removeEventListener('resize', checkMobile)
    }
  }, [])

  const navLinks = [
    {
      name: 'Dealer Logos',
      href: 'https://app.razuna.com/f/l/u0fdmwzu1b6uabqyofzhf',
      external: true
    },
    {
      name: 'Knowledge Library',
      href: 'https://themotorcyclecompany.zendesk.com/auth/v2/login/signin?return_to=https%3A%2F%2Fthemotorcyclecompany.zendesk.com%2Fhc%2Fen-us%2Fcategories%2F9348890012941-Knowledge-Library&theme=hc&locale=en-us&brand_id=9348389597581&auth_origin=9348389597581%2Cfalse%2Ctrue',
      external: true
    },
    {
      name: 'VPN Software',
      href: 'https://drive.google.com/file/d/1Rd7LTytXkJ-FInEzT2HNWOt8ciyabB37/view?usp=sharing',
      external: true
    },
    {
      name: 'Employee Forms Portal',
      href: 'https://tmc-forms.it',
      external: true
    }
  ]

  const MotionNav = isMobile ? 'nav' : motion.nav
  const MotionA = isMobile ? 'a' : motion.a

  return (
    <MotionNav
      initial={isMobile ? {} : { y: -100 }}
      animate={isMobile ? {} : { y: 0 }}
      transition={isMobile ? {} : { duration: 0.8, type: "spring" }}
      className="fixed top-0 left-0 right-0 z-50 bg-transparent"
    >
      <div className="container mx-auto px-4 pt-[5vh] pb-4">
        <div className="flex flex-col items-center">
          <MotionA
            href="#"
            className="flex justify-center"
            initial={isMobile ? {} : { opacity: 0, y: -10 }}
            animate={isMobile ? {} : { opacity: 1, y: 0 }}
            transition={isMobile ? {} : { duration: 0.5 }}
          >
            <img
              src="/imgs/logos/nav_tmc.svg"
              alt="TMC Assist"
              className="h-14 w-auto origin-center scale-[1.8] sm:h-16"
            />
          </MotionA>

          <div className="mt-[3vh] flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
            {navLinks.map((link, index) => (
              <MotionA
                key={link.name}
                href={link.href}
                target={link.external ? "_blank" : undefined}
                rel={link.external ? "noopener noreferrer" : undefined}
                className="text-white hover:text-accent-400 transition-colors duration-300 flex items-center gap-1 text-[calc(0.875rem*1.0506)] sm:text-[calc(1rem*1.0506)]"
                initial={isMobile ? {} : { opacity: 0, y: 10 }}
                animate={isMobile ? {} : { opacity: 1, y: 0 }}
                transition={isMobile ? {} : { delay: 0.1 + index * 0.05, duration: 0.5 }}
              >
                {link.name}
                {link.external && <ExternalLink size={14} />}
              </MotionA>
            ))}
          </div>
        </div>
      </div>
    </MotionNav>
  )
}

export default Navbar
